// @flow
import React from "react";

type Props = {
  className?: string,
};

export const Clock = ({ className }: Props) => (
  <svg
    className={className}
    width="32px"
    height="32px"
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <rect x="0" y="0" width="32" height="32" />
      <circle stroke="#353F52" strokeWidth="2" cx="16" cy="16" r="13" />
      <path
        d="M16,10.8378906 L16,18.421875"
        stroke="#353F52"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M22,18.5 L16,18.5"
        stroke="#353F52"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </g>
  </svg>
);
